import React from "react";
import { useActor } from "@xstate/react";
import SingleSelect from "../SingleSelect";
import { useSignUpMachine } from "../../context/SignUpMachineContext";
import { SignUpFormField } from "../../constants/signup-form-field.enum";
import { YearsOpenValue } from "../../constants/signup-value.enum";
import { BalancedStepTitle } from "../BalancedStepTitle";

const YearsOpenStep: React.FC = () => {
  const machine = useSignUpMachine();
  const [state, send] = useActor(machine);
  const { formData } = state.context;

  const yearsOpenValue = formData[SignUpFormField.YearsOpen];

  const handleChange = (value: any) => {
    send({
      type: "UPDATE_FORM",
      data: { [SignUpFormField.YearsOpen]: value },
    });
  };

  const field = {
    id: SignUpFormField.YearsOpen,
    required: true,
    options: [
      {
        id: "input-age-not-open",
        label: "We're not open yet",
        value: YearsOpenValue.NotOpenYet,
      },
      {
        id: "input-age-less-than-1",
        label: "Less than 1 year",
        value: YearsOpenValue.LessThan1Year,
      },
      {
        id: "input-age-1-5",
        label: "1–5 years",
        value: YearsOpenValue.OneToFiveYears,
      },
      {
        id: "input-age-5-10",
        label: "5–10 years",
        value: YearsOpenValue.FiveToTenYears,
      },
      {
        id: "input-age-10-plus",
        label: "10+ years",
        value: YearsOpenValue.TenPlusYears,
      },
    ],
  };

  return (
    <>
      <div className="tw-flex tw-flex-col tw-items-center tw-space-y-1 tw-text-center">
        <BalancedStepTitle title="How long have you been open?" />
      </div>
      <div className="tw-space-y-4">
        <SingleSelect
          options={field.options}
          onChange={handleChange}
          value={yearsOpenValue}
          progressOnSelect={() => send({ type: "NEXT" })}
        />
      </div>
    </>
  );
};

export default YearsOpenStep;
